export default __webpack_public_path__ + "335159d3a3291e89d69916be13055bec.svg";